import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id E4490267-ACAE-4E86-8747-8D2D620DC707
 * name square-small
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/square-small.svg
 * tags
 */
export const SquareSmallIcon = createSvgIcon(<><path d="M10,14V10H14V14H10Z" /></>, 'SquareSmallIcon');
export default SquareSmallIcon